class VariantReviews extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    this.reviews = this.querySelectorAll('.variant-reviews');
    document.addEventListener('variant:change', (event) => {
      this.updateReviews(event);
    });
  }

  updateReviews(event) {
    const variant = event.detail.variant;
    this.reviews.forEach((review) => {
      const reviewId = review.getAttribute('data-variant-id');
      if (parseInt(reviewId) === variant.id) {
        review.classList.remove('hidden');
      } else {
        review.classList.add('hidden');
      }
    });
  }
}

if (!window.customElements.get('variant-reviews')) {
	window.customElements.define('variant-reviews', VariantReviews);
}
